import { Box, Paper, Typography } from "@mui/material";
import React from "react";
import { Icon } from "@iconify/react";

export default function SubmissionCard({
  label,
  value,
  index,
  icon,
  iconSize,
}) {
  return (
    <Paper
      key={index}
      elevation={0}
      sx={{
        background: "#FFFCE0",
        borderRadius: "10px",
        p: 1.5,
        border: "1px solid #F2ECBD",
      }}
    >
      <Box display="flex" alignItems="center" gap={0.5}>
        <Icon
          icon={icon}
          width={iconSize}
          // height={iconMap[item.label]?.width || 20}
        />
        <Typography fontSize="13px" fontWeight={700} color="#161719">
          {label}
        </Typography>
      </Box>

      <Typography fontSize="13px" fontWeight={600} mt={0.5} color="#572575">
        {value}
      </Typography>
    </Paper>
  );
}
